<template>
  <div class="sp_navMenu">
    <!-- 标签页过多时，点击可左右滑动，标签页少暂时注释 -->
    <!-- <div class="sp_navMenu_left">
      <svg-icon icon-class="arrow-left"
                @click.native="handelLeft"></svg-icon>
    </div> -->
    <div class="sp_navMenu_center"
         ref="sp_navMenu_center">
      <div class="center_scroll"
           ref="center_scroll">
        <div class="nav_item"
             v-for="(val,index) in tabsDataMsg"
             :key="val.name"
             :class="{is_active:activeIndex == index}"
             @click="handelActive(val,index)">
          <span class="item_count"
                :class="{isHome:val.name=='Home'}">{{val.name}}</span>
          <span class="item_icon"
                title="Colse"
                v-show="val.name!=='Home'">
            <svg-icon icon-class="close"
                      @click.native.stop="handelClose(val)"></svg-icon>
          </span>
          <span class="item_line"
                v-if="index!==activeIndex-1&&index!==tabsDataMsg.length-1&&index!==activeIndex"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navMenu',
  props: {
    tabsDataMsg: {
      type: Array,
      required: true,
      default: () => []
    },
    activeMsg: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data () {
    return {
      editableTabs: [{
        title: 'Tab 1',
        name: 1,
      }, {
        title: 'Tab 2',
        name: 2,
      }, {
        title: 'Tab 3',
        name: 3,
      }, {
        title: 'Tab 4',
        name: 4,
      }, {
        title: 'Tab 5',
        name: 5,
      }, {
        title: 'Tab 6',
        name: 6,
      }, {
        title: 'Tab 7',
        name: 7,
      }, {
        title: 'Tab 8',
        name: 8,
      }, {
        title: 'Tab 9',
        name: 9,
      }, {
        title: 'Tab 10',
        name: 10,
      }],
      activeIndex: 0,
    }
  },

  methods: {
    handelLeft () {
      let parentSet = this.$refs['sp_navMenu_center'].getBoundingClientRect();
      let scrollSet = this.$refs['center_scroll'].getBoundingClientRect();
      if (parentSet.left == scrollSet.left) {
        return
      } else {
        this.$refs['center_scroll'].style.transform = `translateX(0px)`;
      }
    },
    handelRight () {
      let parentSet = this.$refs['sp_navMenu_center'].getBoundingClientRect();
      let scrollSet = this.$refs['center_scroll'].getBoundingClientRect();
      let scrollNum = scrollSet.width - parentSet.width;
      if (parentSet.right == scrollSet.right) {
        return
      } else {
        this.$refs['center_scroll'].style.transform = `translateX(-${scrollNum}px)`;
      }
    },

    //激活标签
    handelActive (data, index) {
      this.activeIndex = index;
      this.$router.push({ path: '/layout/' + data.path })
      this.$emit('tabActiveMsg', { val: data, index: index })
    },

    //关闭标签页
    handelClose (val) {
      this.$emit('tabCloseMsg', val)
      this.activeIndex = this.activeMsg
    }
  },

  watch: {
    activeMsg: {
      handler (val) {
        this.activeIndex = val;
      },
      immediate: true,
      deep: true,
    },
  },

  created () {
    // this.activeIndex = this.activeMsg//第一次进来没有走监听，这里初始赋值
  },



}
</script>

<style scoped lang="scss">
.sp_navMenu {
  width: 100%;
  height: 44px;
  display: flex;
  .sp_navMenu_left {
    width: 30px;
    height: 100%;
    display: flex;
    padding-top: 4px;
    .svg-icon {
      cursor: pointer;
      font-size: 30px;
      color: #c1c1c1;
    }
  }
  .sp_navMenu_center {
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    position: relative;
    margin-top: 5px;
    .center_scroll {
      width: max-content;
      position: absolute;
      display: flex;
      height: 100%;
      transition: all 0.3s;
      .nav_item {
        display: flex;
        width: auto;
        height: 39px;
        cursor: pointer;
        padding: 4px 25px;
        position: relative;
        align-items: center;
        .item_count {
          color: #77808c;
          transition: all 0.3s;
          font-size: 14px;
        }
        .item_icon {
          opacity: 0;
          position: absolute;
          right: 0px;
          transition: all 0.3s;
          margin-top: 2px;
          .svg-icon {
            color: #c1c1c1;
            font-size: 20px;
          }
        }
        .item_line {
          width: 1px;
          height: 16px;
          background: #e1e6ed;
          position: absolute;
          right: 0px;
        }
        &:hover {
          .isHome {
            transform: none !important;
          }
          .item_count {
            color: #333940;
            transform: translateX(-8px);
          }
          .item_icon {
            opacity: 1;
            transform: translateX(-8px);
          }
          .item_count {
            font-weight: 500;
            color: #2684ff;
          }
        }
      }
      .is_active {
        border-top: 1px solid #e1e6ed;
        background: #f0f3f7;
        border-radius: 4px 4px 0 0;
        border-left: 1px solid #e1e6ed;
        border-right: 1px solid #e1e6ed;
        border-bottom: 1px solid #f0f3f7 !important;
        .item_count {
          font-weight: 500;
          color: #2684ff;
        }
      }
    }
  }
  .sp_navMenu_right {
    width: 30px;
    height: 100%;
    display: flex;
    padding-top: 4px;
    .svg-icon {
      cursor: pointer;
      font-size: 30px;
      color: #c1c1c1;
    }
  }
}
</style>